import React from 'react'
import { Link } from 'react-router-dom'
import style from '../styles/games.module.scss'

interface IProps {
  title: string
  url: string
  preview: string
  description: string
}

const SmallCard = ({
  title = '',
  description = '',
  url = '/',
  preview
}: IProps): React.ReactElement => {
  return (
    <Link to={url} className={`${style.card} ${style['card--small']}`}>
      <img
        src={preview}
        width='450px'
        height='450px'
        alt={title}
        className={style.card__image}
      />

      <div className={style.card_content}>
        <h2 className={style['card__title--small']}>{title}</h2>
        <p className={style['card__desc--small']}>{description}</p>
      </div>
    </Link>
  )
}

export default SmallCard
